(() => {
  'use strict';

  const EVENT_NAME = 'etsy_outbound_click';
  const LINK_SELECTOR = '[data-etsy-outbound-link]';
  const FIRST_TOUCH_KEY = 'byzayn_first_touch_source';

  if (window.__byzaynEtsyBridgeTrackingInitialized) return;
  window.__byzaynEtsyBridgeTrackingInitialized = true;

  const safeRun = (callback) => {
    try {
      return callback();
    } catch (_error) {
      return undefined;
    }
  };

  const normalizeSource = (value) => String(value || '').trim().toLowerCase();

  const isPinterestValue = (value) => {
    const normalized = normalizeSource(value);
    return normalized.includes('pinterest') || normalized.includes('pin.it');
  };

  const getCurrentUtmSource = () =>
    safeRun(() => new URL(window.location.href).searchParams.get('utm_source')) || '';

  const hasCurrentPinterestTouch = () =>
    isPinterestValue(getCurrentUtmSource()) || isPinterestValue(document.referrer);

  const readStoredFirstTouch = () =>
    safeRun(() => window.sessionStorage.getItem(FIRST_TOUCH_KEY)) || '';

  const storeFirstTouch = (source) => {
    if (!source) return;
    safeRun(() => window.sessionStorage.setItem(FIRST_TOUCH_KEY, source));
  };

  const getReferrerSource = () =>
    safeRun(() => {
      if (!document.referrer) return '';
      return new URL(document.referrer).hostname.replace(/^www\./, '');
    }) || '';

  const getFirstTouchSource = () => {
    if (hasCurrentPinterestTouch()) {
      storeFirstTouch('pinterest');
      return 'pinterest';
    }

    const storedSource = normalizeSource(readStoredFirstTouch());
    if (storedSource) return storedSource;

    const currentSource = normalizeSource(getCurrentUtmSource());
    const firstTouchSource = currentSource || normalizeSource(getReferrerSource()) || 'byzaynco';
    storeFirstTouch(firstTouchSource);

    return firstTouchSource;
  };

  const getCampaignSource = (firstTouchSource) =>
    hasCurrentPinterestTouch() || firstTouchSource === 'pinterest' ? 'pinterest' : 'byzaynco';

  const buildDestinationUrl = (link, firstTouchSource) => {
    const baseDestinationUrl = link.dataset.baseDestinationUrl || link.href;
    const destinationUrl = new URL(baseDestinationUrl, window.location.origin);
    const campaignSource = getCampaignSource(firstTouchSource);

    destinationUrl.searchParams.set('utm_source', campaignSource);
    destinationUrl.searchParams.set(
      'utm_medium',
      campaignSource === 'pinterest' ? 'paid_social' : 'referral'
    );
    destinationUrl.searchParams.set(
      'utm_campaign',
      campaignSource === 'pinterest'
        ? 'pinterest_shopify_etsy_bridge'
        : 'shopify_etsy_bridge'
    );
    destinationUrl.searchParams.set('utm_content', link.dataset.productHandle || '');

    return destinationUrl.toString();
  };

  const updateLinkDestination = (link) => {
    const firstTouchSource = getFirstTouchSource();
    const destinationUrl = buildDestinationUrl(link, firstTouchSource);

    link.href = destinationUrl;
    link.dataset.firstTouchSource = firstTouchSource;

    return { destinationUrl, firstTouchSource };
  };

  const getVariantId = (link) => {
    const productFormId = link.dataset.productFormId;
    const productForm = productFormId ? document.getElementById(productFormId) : null;
    const variantInput = productForm?.querySelector('input[name="id"]');

    return variantInput?.value || link.dataset.variantId || '';
  };

  const publishToShopifyAnalytics = (payload) => {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;

    const result = safeRun(() => publish.call(window.Shopify.analytics, EVENT_NAME, payload));
    if (result && typeof result.catch === 'function') {
      result.catch(() => {});
    }
  };

  const publishEvent = (payload) => {
    safeRun(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: EVENT_NAME, ...payload });
    });

    safeRun(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', EVENT_NAME, payload);
      }
    });

    safeRun(() => {
      if (typeof window.pintrk === 'function') {
        window.pintrk('track', EVENT_NAME, payload);
      }
    });

    publishToShopifyAnalytics(payload);
  };

  const handleOutboundClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest(LINK_SELECTOR);
    if (!(link instanceof HTMLAnchorElement)) return;

    const { destinationUrl, firstTouchSource } = updateLinkDestination(link);
    const payload = {
      product_id: link.dataset.productId || '',
      product_handle: link.dataset.productHandle || '',
      product_title: link.dataset.productTitle || '',
      variant_id: getVariantId(link),
      placement: link.dataset.placement || 'product_page_below_payment_options',
      first_touch_source: firstTouchSource,
      destination: 'etsy',
      destination_url: destinationUrl,
      page_location: window.location.href,
      timestamp: new Date().toISOString(),
    };

    publishEvent(payload);
  };

  const updateRenderedLinks = () => {
    document.querySelectorAll(LINK_SELECTOR).forEach((link) => {
      if (link instanceof HTMLAnchorElement) updateLinkDestination(link);
    });
  };

  document.addEventListener('click', handleOutboundClick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateRenderedLinks, { once: true });
  } else {
    updateRenderedLinks();
  }
})();
